import { render, staticRenderFns } from "./LeagueSelectorDropdown.vue?vue&type=template&id=5d91a90a&"
import script from "./LeagueSelectorDropdown.vue?vue&type=script&lang=js&"
export * from "./LeagueSelectorDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports